var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#EAF2FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0049 16.0028C30.08 16.0028 35.0049 18.6891 35.0049 22.0028V26.0028C35.0049 29.3165 30.08 32.0028 24.0049 32.0028C18.0382 32.0028 13.1811 29.4116 13.0096 26.1797L13.0049 26.0028V22.0028C13.0049 18.6891 17.9298 16.0028 24.0049 16.0028ZM24.0049 28.0028C20.2844 28.0028 16.9954 26.9953 15.0047 25.4533L15.0049 26.0028C15.0049 27.885 18.8875 30.0028 24.0049 30.0028C29.0156 30.0028 32.8426 27.9723 32.9999 26.1207L33.0049 26.0028L33.0061 25.4525C31.0155 26.995 27.726 28.0028 24.0049 28.0028ZM24.0049 18.0028C18.8875 18.0028 15.0049 20.1206 15.0049 22.0028C15.0049 23.885 18.8875 26.0028 24.0049 26.0028C29.1223 26.0028 33.0049 23.885 33.0049 22.0028C33.0049 20.1206 29.1223 18.0028 24.0049 18.0028Z",
    fill: "#0F62FE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLending);
export default __webpack_public_path__ + "static/media/lending.7e863514ac597cf0af0c97c6532c139d.svg";
export { ForwardRef as ReactComponent };